import { BasePage } from '@/components/ui/base-page'

export function GreenHousesPage() {
  return (
    <BasePage
      title="Greenhouses"
      description="Franchised greenhouses — financing and solutions for greenhouse and controlled-environment agriculture."
    >
      <div className="prose dark:prose-invert max-w-none">
        <p>Our greenhouse franchise offering supports greenhouse and controlled-environment agriculture projects. Content can be expanded here.</p>
      </div>
    </BasePage>
  )
}
